export { getProductInventory, getProductInventoryPairs } from '@libs/api-proxy-client';
